import type { Style } from 'mapbox-gl';
import { tilesUrl } from '../../../../utils/mapUtils';

export const mapStyle: {
  containerStyle: React.CSSProperties;
  style: string | Style;
  movingMethod: 'jumpTo' | 'easeTo' | 'flyTo';
  renderChildrenInPortal: boolean;
} = {
  containerStyle: {
    height: `calc(100vh - 60px)`,
    width: '100%',
  },
  movingMethod: 'easeTo',
  style: tilesUrl,
  renderChildrenInPortal: true,
};

export const mapStyleMobile: {
  containerStyle: React.CSSProperties;
  style: string | Style;
  movingMethod: 'jumpTo' | 'easeTo' | 'flyTo';
  renderChildrenInPortal: boolean;
} = {
  containerStyle: {
    height: `100%`,
    width: '100%',
  },
  movingMethod: 'easeTo',
  style: tilesUrl,
  renderChildrenInPortal: true,
};

export const zoomControlMobileStyle = {
  right: 10,
  left: 'auto',
  top: '50%',
  transform: 'translateY(-50%)',
};

export const layersControlStyle = {
  mobile: {
    top: '50%',
    transform: 'translateY(-50%)',
  },
  desktop: {
    top: 135,
    width: 'inherit',
  },
};
